<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    export default {
        name: "ShopCard",
        props: ['shop'],
        data() {
          return {
              id: this.$props.shop.id,
              name: this.$props.shop.name,
              city: this.$props.shop.city,
              address: this.$props.shop.address,
          }
        },
        computed: {
            description() {
                let str = "";
                if (this.$props.shop.description.split(" ").length > 12 ) {
                    str = " [...]";
                }
                return this.$props.shop.description.split(" ").slice(0, 12).join(" ") + str;
            }
        },
        methods: {
            goToStoreDetails(id) {
                this.$router.push('/negozio/' + id);
            }
        }
    }
</script>
